/** Get Summary Dashboard data */
export const SET_DATES = "SET_DATES";
export const GET_ACTIVE_CAMERA = "GET_ACTIVE_CAMERA";
export const SET_ACTIVE_SUB_GROUP = "SET_ACTIVE_SUB_GROUP";